<template>
    <div class="scan-ticket-detail__list-table">
        <div class="table">
            <span class="table__title">{{ getTranslatedText('ticket') }}</span>

            <div class="table__list">
                <div class="table__item" v-for="(v, i) in details" :key="i">
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label uppercase bold">
                            {{ v.bet.market.market }}
                        </span>
                        <div class="table-list-number" v-for="(bet, index) in v.bet.bets" :key="index">
                            <span v-if="index > 0">+</span>
                            <div class="table-item-number" v-for="(number, j) in bet" :key="j">
                                {{ number }}
                            </div>
                        </div>
                    </div>
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label">
                            {{ getTranslatedText('stake') }}
                        </span>
                        <span class="table__item--text table__item--text-value highlight">
                            {{ renderPrice(v.wager) }}
                        </span>
                    </div>
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label">
                            {{ getTranslatedText('Name of Game') }}
                        </span>
                        <span class="table__item--text table__item--text-value">
                            {{ v.bet?.event?.drawName || '' }}
                        </span>
                    </div>
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label">
                            {{ getTranslatedText('Draw time/date') }}
                        </span>
                        <span class="table__item--text table__item--text-value"> {{ renderDate(v.draw_date) }} </span>
                    </div>
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label">
                            {{ getTranslatedText('Number Lines') }}
                        </span>
                        <span class="table__item--text table__item--text-value"> {{ v.bet.combinations }} </span>
                    </div>
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label">
                            {{ getTranslatedText('Possible Winnings') }}
                        </span>
                        <span class="table__item--text table__item--text-value">
                            {{ renderPrice(v.bet.potentialWinnings) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table">
            <span class="table__title">{{ getTranslatedText('draw') }}</span>
            <div class="table__list">
                <div class="table__item" v-for="(value, index) in events" :key="index">
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label">
                            {{ getTranslatedText('draw date') }}
                        </span>
                        <span class="table__item--text table__item--text-value">
                            {{ renderDate(value.draw_date) }}
                        </span>
                    </div>
                    <div class="table__item-content">
                        <span class="table__item--text table__item--text-label">
                            {{ getTranslatedText('result') }}
                        </span>
                        <template v-if="value.results && value.results.length > 0">
                            <div class="table-list-number" v-for="(bet, index) in value.results" :key="index">
                                <div
                                    v-if="bet.length > LOTTO_INSTANT.INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT"
                                    class="table-list-number-box"
                                >
                                    <div class="table-item-number-box">
                                        <div
                                            class="table-item-number"
                                            v-for="(number, j) in renderItemBalls(
                                                1,
                                                bet,
                                                LOTTO_INSTANT.INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT,
                                            )"
                                            :key="j"
                                        >
                                            {{ number }}
                                        </div>
                                    </div>
                                    <div class="table-item-number-box">
                                        <div
                                            class="table-item-number"
                                            v-for="(number, j) in renderItemBalls(
                                                2,
                                                bet,
                                                LOTTO_INSTANT.INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT,
                                            )"
                                            :key="j"
                                        >
                                            {{ number }}
                                        </div>
                                    </div>
                                </div>
                                <template v-else>
                                    <span v-if="index > 0">+</span>
                                    <div class="table-item-number" v-for="(number, j) in bet" :key="j">
                                        {{ number }}
                                    </div>
                                </template>
                            </div>
                        </template>
                        <span v-else class="table__item--text table__item--text-value">
                            {{ getTranslatedText('pending results') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { LOTTO_INSTANT } from '@/constants/lotto/instant-lotto';
import languageMixins from '@/mixins/language-mixins';

import { formatDateUTC, formatPrice, splitDataLottoInstant } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    props: {
        details: {
            type: Array,
            default: () => [],
        },
        events: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            height: '',
            LOTTO_INSTANT,
        };
    },
    methods: {
        renderDate(date) {
            const dateFormat = formatDateUTC(date, 2);

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            return valueDate;
        },

        renderItemBalls(type, data, number) {
            console.log('🚀 ~ renderItemBalls ~ type:', type);
            console.log('🚀 ~ renderItemBalls ~ data:', data);
            console.log(splitDataLottoInstant(type, data, number));

            return splitDataLottoInstant(type, data, number);
        },

        renderPrice(price) {
            return formatPrice(price);
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/scan/scanDetail.scss';
</style>
